import { Button } from '@/components/ui/button'
import { List } from 'lucide-react'
import { Message } from '@/hooks/useConversationMessages'
import { cn } from '@/lib/utils'
import { parseWhatsAppFormatting } from './messageUtils'

interface ListMessageProps {
  message: Message
}

export function ListMessage({ message }: ListMessageProps) {
  let displayText = message.content_text || 'Please choose an option'
  let buttonLabel = 'View options'
  let headerText: string | null = null
  let footerText: string | null = null

  try {
    const contentData = JSON.parse(message.content_text || '{}')

    if (contentData.body?.text) displayText = contentData.body.text
    else if (contentData.text) displayText = contentData.text

    if (contentData.action?.button) buttonLabel = contentData.action.button
    else if (contentData.buttonLabel) buttonLabel = contentData.buttonLabel

    if (contentData.header?.text) headerText = contentData.header.text
    else if (contentData.headerText) headerText = contentData.headerText

    if (contentData.footer?.text) footerText = contentData.footer.text
    else if (contentData.footerText) footerText = contentData.footerText
  } catch (e) {
    displayText = message.content_text || 'Please choose an option'
  }

  const isOutbound = !message.is_inbound

  return (
    <div className="space-y-0">
      {headerText && (
        <div className="text-sm font-semibold mb-2 text-gray-900">
          {headerText}
        </div>
      )}

      <div className={cn(
        "rounded-lg shadow-sm border",
        isOutbound 
          ? "bg-white border-gray-200" 
          : "bg-white border-gray-200"
      )}>
        {displayText && displayText.trim() && (
          <div className="px-3 pb-2">
            <div className="text-sm whitespace-pre-wrap leading-relaxed text-gray-900">
              {displayText.split('\n').map((line, index) => (
                <div key={index} className="mb-1">
                  {parseWhatsAppFormatting(line)}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="border-t border-gray-200" />

        <div>
          <Button
            variant="ghost"
            className={cn(
              "w-full justify-center text-sm font-medium py-2 px-3 rounded-md transition-all",
              "text-[#1EB677] hover:text-[#0F8A55] hover:bg-[#E8F8F0]"
            )}
            size="sm"
            disabled={true}
          >
            <List className="h-4 w-4 mr-2" />
            <span>{buttonLabel}</span>
          </Button>
        </div>
      </div>

      {footerText && (
        <div className="text-xs mt-2 text-gray-600">
          {footerText}
        </div>
      )}
    </div>
  )
}

